import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import Hero from "./components/Hero";
import HotRanking from "./components/HotRanking";
import LatestFeed from "./components/LatestFeed";
import TopicsSection from "./components/TopicsSection";
import EditorPicks from "./components/EditorPicks";
import CommunitySection from "./components/CommunitySection";
import UpdateCta from "./components/UpdateCta";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-body">
      <SiteHeader />
      <main className="w-full">
        <Hero />
        <HotRanking />
        <LatestFeed />
        <TopicsSection />
        <EditorPicks />
        <CommunitySection />
        <UpdateCta />
      </main>
      <SiteFooter />
    </div>
  );
}